/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'
import { CardColorProps } from '../BaseIcon'

export const Amex: FunctionComponent<CardColorProps> = ({ blackAndWhite = false }) => (
  <React.Fragment>
    {!blackAndWhite && (
      <React.Fragment>
        <rect width='40' height='24' rx='2' fill='#016FD0' />
        <path d='M3.4399 7.8777L2.77768 6.23325L2.11546 7.8777H3.4399Z' fill='white' />
        <path
          d='M19.4419 6.19103H18.0974V7.18214H19.4597C19.6952 7.18214 19.9997 6.99992 19.9997 6.68658C19.9997 6.44214 19.7641 6.19103 19.4419 6.19103Z'
          fill='white'
        />
        <path d='M29.014 6.23325L29.6762 7.8777H28.3518L29.014 6.23325Z' fill='white' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0 7.85981L1.5 4.36426H4.09333L4.94444 6.32204V4.36426H8.16889L8.67556 5.77981L9.16667 4.36426H23.6378V5.07537C23.6378 5.07537 24.3978 4.36426 25.6489 4.36426L30.3444 4.37981L31.18 6.31315V4.36426H33.8778L34.62 5.47537V4.36426H37.3422V10.6443H34.62L33.9089 9.53092V10.6443H29.9444L29.5467 9.65537H28.4822L28.0911 10.6443H25.4022C24.3267 10.6443 23.6378 9.94648 23.6378 9.94648V10.6443H19.5822L18.7778 9.65537V10.6443H3.70889L3.31111 9.65537H2.24889L1.85333 10.6443H0V7.85981ZM0.00878906 9.83992L2.03101 5.1377H3.56434L5.58434 9.83992H4.23768L3.86657 8.8977H1.69768L1.32434 9.83992H0.00878906ZM5.72266 5.1377V9.83992H6.89821V6.37547L8.14932 9.83992H9.18044L10.4249 6.37547V9.83992H11.6004V5.1377H9.74488L8.68266 8.17547L7.59377 5.14436L5.72266 5.1377ZM12.4043 9.83992V5.1377H16.2421V6.18881H13.5932V6.99325H16.1798V7.98436H13.5932V8.81992H16.2421V9.83992H12.4043ZM16.9219 9.83992V5.1377H19.5352C20.4019 5.1377 21.1797 5.67325 21.1797 6.66214C21.1797 7.50881 20.5263 8.05325 19.8908 8.10659L21.4374 9.83992H20.0019L18.593 8.16881H18.0974V9.83992H16.9219ZM22.8621 9.83992H21.6621V5.1377H22.8621V9.83992ZM25.4462 9.83992H25.7062L26.1996 8.81325H25.8907C25.1418 8.81325 24.6218 8.43103 24.6218 7.51992C24.6218 6.75325 25.0773 6.25103 25.7196 6.25103H27.0662V5.1377H25.7662C24.184 5.1377 23.4307 6.13103 23.4307 7.50881C23.4307 8.85325 24.1929 9.83992 25.4462 9.83992ZM28.2673 5.1377L26.2451 9.83992H27.5607L27.934 8.8977H30.1029L30.474 9.83992H31.8207L29.8007 5.1377H28.2673ZM31.958 5.1377V9.83992H33.1336V6.80881L35.0891 9.83992H36.5358V5.1377H35.3602V8.09103L33.4513 5.1377H31.958Z'
          fill='white'
        />
        <path
          d='M20.3282 14.4311H19.0238V15.5156H20.3238C20.6682 15.5156 20.9082 15.2867 20.9082 14.9734C20.9082 14.6378 20.666 14.4311 20.3282 14.4311Z'
          fill='white'
        />
        <path
          d='M23.7888 14.4178H25.1333C25.4555 14.4178 25.6911 14.6689 25.6911 14.9134C25.6911 15.2267 25.3866 15.4089 25.1511 15.4089H23.7888V14.4178Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.76367 18.8733V12.5933H14.4126L15.1259 13.5222L15.8637 12.5933H39.9992V13.3687H37.7556C36.3822 13.3687 35.9111 14.0953 35.9111 14.8487C35.9111 15.6953 36.4245 16.2575 37.3489 16.2575H38.3134C38.6622 16.2575 38.8134 16.4575 38.8134 16.6553C38.8134 16.8598 38.6622 17.0487 38.3134 17.0487H36.06V18.0687H38.4667C39.4784 18.0687 39.9768 17.426 39.9992 16.6297V18.4399C39.9992 18.4399 39.3681 18.8666 38.637 18.8733H25.2726L24.4681 17.8844V18.8733H21.8348V17.1844C21.8348 17.1844 21.4748 17.4199 20.697 17.4199H19.7992V18.8733H15.8081L15.0948 17.9244L14.3703 18.8733H7.76367ZM8.56934 18.0689V13.3667H12.4049V14.4178H9.75822V15.2223H12.3449V16.2134H9.75822V17.0489H12.4049V18.0689H8.56934ZM27.3662 13.3667V18.0689H31.2018V17.0489H28.5529V16.2134H31.1262V15.2223H28.5529V14.4178H31.2018V13.3667H27.3662ZM12.5532 18.0689L14.4221 15.7467L12.5088 13.3667H13.991L15.1288 14.8378L16.2732 13.3667H17.6955L15.8088 15.7178L17.6799 18.0689H16.1977L15.0932 16.62L14.0132 18.0689H12.5532ZM17.8193 18.0689V13.3667H20.4149C21.4816 13.3667 22.1038 14.0534 22.1038 14.9489C22.1038 16.0289 21.3104 16.5845 20.2638 16.5845H19.026V18.0689H17.8193ZM22.6133 13.3667V18.0689H23.7888V16.3978H24.2844L25.6933 18.0689H27.1288L25.5822 16.3356C26.2177 16.2823 26.8711 15.7378 26.8711 14.8911C26.8711 13.9023 26.0933 13.3667 25.2266 13.3667H22.6133ZM31.7463 17.0487V18.0687H34.2529C35.2885 18.0687 35.7863 17.3953 35.7863 16.5731C35.7863 15.8087 35.3396 15.2242 34.3085 15.2242H33.1952C32.9063 15.2242 32.7618 15.0109 32.7618 14.8153C32.7618 14.6242 32.8796 14.4264 33.2574 14.4264H35.2374L35.7329 13.3687H33.4441C32.0707 13.3687 31.5996 14.0953 31.5996 14.8487C31.5996 15.6953 32.1129 16.2575 33.0374 16.2575H34.0996C34.4485 16.2575 34.5996 16.4575 34.5996 16.6553C34.5996 16.8598 34.4485 17.0487 34.0996 17.0487H31.7463Z'
          fill='white'
        />
        <path
          d='M39.9992 16.5177V13.3703L39.5045 14.4264H37.5711C37.1934 14.4264 37.0756 14.6242 37.0756 14.8153C37.0756 15.0109 37.22 15.2242 37.5089 15.2242H38.5222C39.5283 15.2242 39.978 15.7806 39.9992 16.5177Z'
          fill='white'
        />
      </React.Fragment>
    )}
    {blackAndWhite && (
      <React.Fragment>
        <g clipPath='url(#clip0_20400_19)'>
          <rect width='40' height='24' rx='2' fill='white' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.2119 17.9997V12.8057H15.531L16.1017 13.5739L16.6919 12.8057H36.0003V17.6413C36.0003 17.6413 35.4954 17.9942 34.9105 17.9997H24.219L23.5754 17.1818V17.9997H21.4688V16.6029C21.4688 16.6029 21.1808 16.7977 20.5586 16.7977H19.8403V17.9997H16.6475L16.0768 17.2149L15.4972 17.9997H10.2119Z'
            fill='white'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3 11.1941L5.2 6H7.27466L7.95554 7.61924V6H10.5351L10.9404 7.17078L11.3333 6H22.9102V6.58814C22.9102 6.58814 23.5182 6 24.5191 6L28.2755 6.01287L28.9439 7.61188V6H31.1021L31.6959 6.91898V6H33.8737V11.1941H31.6959L31.127 10.2732V11.1941H27.9555L27.6373 10.3762H26.7857L26.4728 11.1941H24.3217C23.4613 11.1941 22.9102 10.6169 22.9102 10.6169V11.1941H19.6657L19.0222 10.3762V11.1941H6.9671L6.64888 10.3762H5.79911L5.48266 11.1941H4H3Z'
            fill='white'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5.62363 6.63916L4.00586 10.5283H5.0583L5.35697 9.74898H7.09207L7.38896 10.5283H8.46629L6.8503 6.63916H5.62363ZM6.22096 7.54527L6.75074 8.90535H5.69119L6.22096 7.54527Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.57812 10.5283V6.63916L10.075 6.64467L10.9461 9.15164L11.7959 6.63916H13.2803V10.5283H12.3399V7.6629L11.3443 10.5283H10.5195L9.51857 7.6629V10.5283H8.57812Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M13.9229 10.5283V6.63916H16.9931V7.50851H14.874V8.17385H16.9433V8.99358H14.874V9.68465H16.9931V10.5283H13.9229Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M17.5381 6.63916V10.5283H18.4785V9.14613H18.875L20.0021 10.5283H21.1505L19.9132 9.09466C20.4216 9.05055 20.9443 8.60026 20.9443 7.9C20.9443 7.08211 20.3221 6.63916 19.6287 6.63916H17.5381ZM18.4785 7.51035H19.5541C19.8119 7.51035 20.0003 7.71804 20.0003 7.92021C20.0003 8.17936 19.7567 8.33008 19.5683 8.33008H18.4785V7.51035Z'
            fill='black'
          />
          <path fillRule='evenodd' clipRule='evenodd' d='M22.2891 10.5283H21.3291V6.63916H22.2891V10.5283Z' fill='black' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M24.5656 10.5283H24.3576C23.3549 10.5283 22.7451 9.71222 22.7451 8.60026C22.7451 7.46073 23.3478 6.63916 24.6136 6.63916H25.6536V7.55997H24.5762C24.0624 7.55997 23.698 7.97535 23.698 8.60944C23.698 9.363 24.114 9.67913 24.7131 9.67913H24.9602L24.5656 10.5283Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M26.6129 6.63916L24.9951 10.5283H26.0476L26.3462 9.74898H28.0813L28.3782 10.5283H29.4555L27.8396 6.63916H26.6129ZM27.2102 7.54527L27.74 8.90535H26.6804L27.2102 7.54527Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M29.5664 10.5283V6.63916H30.7611L32.2882 9.0818V6.63916H33.2286V10.5283H32.0713L30.5068 8.0213V10.5283H29.5664Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.8564 17.3354V13.4463H13.9249V14.3156H11.8076V14.981H13.8769V15.8007H11.8076V16.4918H13.9249V17.3354H10.8564Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M25.8936 17.3354V13.4463H28.962V14.3156H26.8429V14.981H28.9015V15.8007H26.8429V16.4918H28.962V17.3354H25.8936Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14.0414 17.3354L15.5365 15.4147L14.0059 13.4463H15.1916L16.1019 14.663L17.0174 13.4463H18.1552L16.6459 15.3908L18.1427 17.3354H16.957L16.0734 16.1371L15.2094 17.3354H14.0414Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18.2559 13.4463V17.3354H19.2212V16.1076H20.2114C21.0487 16.1076 21.6834 15.6482 21.6834 14.7549C21.6834 14.0142 21.1856 13.4463 20.3323 13.4463H18.2559ZM19.2212 14.3267H20.263C20.5332 14.3267 20.727 14.4976 20.727 14.7751C20.727 15.0343 20.535 15.2236 20.2594 15.2236H19.2194V14.3267H19.2212Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M22.0908 13.4463V17.3354H23.0313V15.9533H23.4277L24.5548 17.3354H25.7033L24.4659 15.9018C24.9744 15.8577 25.497 15.4074 25.497 14.7071C25.497 13.8892 24.8748 13.4463 24.1815 13.4463H22.0908ZM23.0313 14.3156H24.1068C24.3646 14.3156 24.553 14.5233 24.553 14.7255C24.553 14.9847 24.3095 15.1354 24.121 15.1354H23.0313V14.3156Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M29.3966 17.335V16.4914H31.2793C31.5584 16.4914 31.6793 16.3352 31.6793 16.1661C31.6793 16.0025 31.5584 15.8371 31.2793 15.8371H30.4295C29.69 15.8371 29.2793 15.3721 29.2793 14.6718C29.2793 14.0488 29.6562 13.4478 30.7548 13.4478H32.586L32.1895 14.3226H30.6055C30.3033 14.3226 30.2091 14.4862 30.2091 14.6443C30.2091 14.806 30.3246 14.9824 30.5557 14.9824H31.4464C32.2713 14.9824 32.6286 15.4658 32.6286 16.0981C32.6286 16.7781 32.2304 17.335 31.402 17.335H29.3966Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M32.8476 17.335V16.4914H34.6503C34.9294 16.4914 35.0503 16.3352 35.0503 16.1661C35.0503 16.0025 34.9294 15.8371 34.6503 15.8371H33.8787C33.1392 15.8371 32.7285 15.3721 32.7285 14.6718C32.7285 14.0488 33.1054 13.4478 34.2041 13.4478H35.9996L35.6032 14.3226H34.0565C33.7543 14.3226 33.6601 14.4862 33.6601 14.6443C33.6601 14.806 33.7756 14.9824 34.0067 14.9824H34.8174C35.6423 14.9824 35.9996 15.4658 35.9996 16.0981C35.9996 16.7781 35.6014 17.335 34.773 17.335H32.8476Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M38 1H2C1.44771 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H38C38.5523 23 39 22.5523 39 22V2C39 1.44772 38.5523 1 38 1ZM2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.895431 24 2 24H38C39.1046 24 40 23.1046 40 22V2C40 0.895431 39.1046 0 38 0H2Z'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_20400_19'>
            <rect width='40' height='24' rx='2' fill='white' />
          </clipPath>
        </defs>
      </React.Fragment>
    )}
  </React.Fragment>
)
